<template>
  <el-dialog title="新增评论回复" :visible.sync="visible" width="40%" :close-on-click-modal="false">
    <el-form :model="form" label-width="100px">
      <el-form-item label="所属评价ID" prop="reviewId">
        <el-select v-model="form.reviewId" placeholder="请选择所属评价ID">
          <el-option
            v-for="item in uniqueReviewList"
            :label="item.reviewId"
            :key="item.reviewId"
            :value="item.reviewId"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="用户ID" prop="userId">
        <el-input v-model="form.userId" placeholder="请输入用户ID" />
      </el-form-item>
      <el-form-item label="用户昵称" prop="userName">
        <el-input v-model="form.userName" placeholder="请输入用户昵称" />
      </el-form-item>
      <el-form-item label="父回复ID" prop="parentReplyId">
        <el-input v-model="form.parentReplyId" placeholder="请输入父回复ID" />
      </el-form-item>
      <el-form-item label="回复内容" prop="content">
        <el-input type="textarea" v-model="form.content" placeholder="请输入回复内容" :rows="4" />
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">取消</el-button>
      <el-button type="primary" @click="handleSubmit">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { addReviewReply } from "@/api/goodsReview";

export default {
  name: "AddReply",
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    reviewList: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    uniqueReviewList() {
      const seen = new Set();
      return this.reviewList.filter(item => {
        if (seen.has(item.reviewId)) {
          return false;
        }
        seen.add(item.reviewId);
        return true;
      });
    }
  },
  data() {
    return {
      form: {
        reviewId: "",
        userId: "",
        userName: "",
        parentReplyId: "",
        content: ""
      }
    };
  },
  watch: {
    visible(val) {
      if (val) {
        this.resetForm();
      }
    }
  },
  methods: {
    resetForm() {
      this.form = {
        reviewId: "",
        userId: "",
        userName: "",
        parentReplyId: "",
        content: ""
      };
    },
    handleCancel() {
      this.$emit("update:visible", false);
    },
    handleSubmit() {
      if (!this.form.reviewId) {
        this.$message({
          type: "warning",
          message: "请输入评论ID"
        });
        return;
      }
      if (!this.form.userId) {
        this.$message({
          type: "warning",
          message: "请输入用户ID"
        });
        return;
      }
      if (!this.form.userName) {
        this.$message({
          type: "warning",
          message: "请输入用户昵称"
        });
        return;
      }
      if (!this.form.content) {
        this.$message({
          type: "warning",
          message: "请输入回复内容"
        });
        return;
      }
      addReviewReply({
        reviewId: this.form.reviewId,
        userId: this.form.userId,
        userName: this.form.userName,
        userImage: this.form.userImage,
        parentReplyId: this.form.parentReplyId || null,
        content: this.form.content
      }).then(resp => {
        if (resp && resp.bizcode === 100) {
          this.$message({
            type: "success",
            message: "新增成功"
          });
          this.$emit("update:visible", false);
          this.$emit("success");
        } else {
          this.$message({
            type: "error",
            message: resp.msg || "新增失败"
          });
        }
      });
    }
  }
};
</script>

<style scoped lang="scss"></style>
